<template>
  <!-- 学历证书 -->
  <div class="diplomaPage">
    <p class="fgx"></p>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.schoolName"
        label="院校名称"
        required
        :readonly="!editType"
        :placeholder="editType?'请输入...  ' : '' "
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.specialty"
        label="专业"
        :readonly="!editType"
        :placeholder="editType?'请输入...  ':''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.certificateNumber"
        label="证书编号"
        :required="editType"
        :readonly="!editType"
        :placeholder="editType?'请输入...  ':''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        label="学历层次"
        readonly
        :required="editType"
        v-model="credentialGradeName"
        @click="showEducationLevel"
        :is-link="editType"
        :placeholder="editType?'请选择':''"
        class="ggInput"
      />
    </van-cell-group>

    <van-cell-group class="baseNone baseSalary">
      <van-field
        readonly
        label="入学日期"
        v-model="baseData.startDate"
        :required="editType"
        @click="TimePicker(1)"
        :is-link="editType"
        :placeholder="editType?'请选择':''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        readonly
        label="毕业日期"
        v-model="baseData.endDate"
        @click="TimePicker(2)"
        :is-link="editType"
        :placeholder="editType?'请选择':''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary summaryBox beizhu">
      <!-- <p>备注：</p> -->
      <van-field
        label="备注："
        v-model="baseData.remarks"
        rows="1"
        autosize
        :readonly="!editType"
        type="textarea"
        :placeholder="editType?'请输入...  ':''"
        class="minRows"
      />
    </van-cell-group>
    <!-- 附件组件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="baseData"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :files="baseData"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>

    <div class="btnBox" v-if="this.commonType == 'add'">
      <a href="javascript:void(0);" class="btn" @click="checkInput">保存</a>
    </div>
    <div
      class="btnBox editBtnbox clearfix"
      v-if=" this.commonType == 'edit' && this.editType==true"
    >
      <a href="javascript:void(0);" class="btn fl" @click="delApply">删除</a>

      <a href="javascript:void(0);" class="btn fr" @click="checkInput">保存</a>
    </div>
    <!-- 学历层次弹框 -->
    <van-popup v-model="showEducationLevelPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="educationLevelList"
        value-key="dictName"
        @cancel="showEducationLevelPicker = false"
        @confirm="saveEducationLevel"
      />
    </van-popup>

    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
import { dateFormat, getDictList } from "@/utils/common";
import { getDeviceType,is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "credential",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      commonType: "", // 返回当前表单时 新增 ？查看？ 编辑？
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑
      baseData: {
        //基本信息
        baseAnnexes: [], //附件
        certificateNumber: "", //证书编号
        educationLevel: "", //学历层次 zk,专科；bk,本科；ss,硕士；bs,博士
        endDate: "", //毕业时间
        remarks: "", //备注
        schoolName: "", //院校名称
        specialty: "", //专业
        startDate: "", //入学时间
        uid: "" //用户id
      },
      credentialGradeName: "", //学历层次
      showEducationLevelPicker: false, //学历等级弹框
      educationLevelList: [
        {
          dictName: "大专",
          dictCode: "zk"
        },
        {
          dictName: "本科",
          dictCode: "bk"
        },
        {
          dictName: "硕士",
          dictCode: "ss"
        },
        {
          dictName: "博士",
          dictCode: "bs"
        }
      ], //学历等级列表
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      checkIndex: "", // 获取证书发放和到期时间
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false ,//防止高频点击
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.commonId = this.$route.query.commonId; //证书Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    window.editPage = this.editPage; //编辑页面
    this.$nextTick(() => {
      this.baseData.uid = this.userinfo.id;
      if (this.commonType == "edit") {
        this.initPage();
      } else {
        this.setShowLoad(false);
        this.editType = true;
      }
    });
  },
  components: {
    refreshPage,
    fileView,
      wxFileView,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
      _this.$api.userCenter.user.myInfo
        .getDiplomaDetail(_this.commonId)
        .then(res => {
          if (res.code == "1") {
            _this.setShowLoad(false);
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            if (res.data.educationLevel != null) {
              if (res.data.educationLevel == "xueli001") {
                _this.credentialGradeName = "本科";
              } else if (res.data.educationLevel == "xueli002") {
                _this.credentialGradeName = "大专";
              } else if (res.data.educationLevel == "xueli003") {
                _this.credentialGradeName = "研究生";
              } else if (res.data.educationLevel == "xueli004") {
                _this.credentialGradeName = "博士及以上";
              } else {
                _this.credentialGradeName = "暂无";
              }
            }
            // _this.editPage();
          } else {
            if (_this.clientType == "android") {
              //安卓
              window.android.getInfo(103);
            } else {
              //IOS
              window.webkit.messageHandlers.closePage.postMessage("1");
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    editPage() {
      //点击编辑页面
      this.editType = true;
    },

    showEducationLevel() {
      //判断当前是否编辑状态
      if (this.editType) {
        this.showEducationLevelPicker = true;
      }
    },
    saveEducationLevel(data) {
      this.showEducationLevelPicker = false;
      this.credentialGradeName = data.dictName;
      this.baseData.educationLevel = data.dictCode;
    },

    TimePicker(type) {
      if (!this.editType) {
        this.showTimePicker = false;
        return;
      }
      this.checkIndex = type;
      this.showTimePicker = true;
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;
      if (this.checkIndex == "1") {
        this.baseData.startDate = dateFormat(data);
      } else {
        this.baseData.endDate = dateFormat(data);
      }
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.baseData.baseAnnexes = data;
    },

    delApply() {
      //删除资质证书记录
      let _this = this;
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除学历证书"
        })
        .then(() => {
          _this.$api.userCenter.user.myInfo
            .deleteDiploma(_this.commonId)
            .then(res => {
              if (res.code == "1") {
                _this.$toast("学历证书删除成功！");
                setTimeout(function() {
                  console.log("关闭页面");
                  //将当前页面关闭
                  if (_this.clientType == "android") {
                    //安卓
                    window.android.getInfo(103);
                  } else {
                    //IOS
                    window.webkit.messageHandlers.closePage.postMessage("1");
                  }
                }, 3000);
              } else {
                _this.$toast(res.msg);
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          // 取消删除操作
        });
    },

    backPage() {
      if (this.clientType == "android") {
        window.android.getInfo(103);
      } else {
        //IOS
        window.webkit.messageHandlers.closePage.postMessage("1");
      }
    },
    checkInput() {
      let _this = this;
      if (_this.addType == true) {
        _this.$toast("请不要频繁提交！");
      } else {
        _this.addType = true;
        if (
          _this.baseData.certificateNumber == "" ||
          _this.baseData.educationLevel == "" ||
          _this.baseData.endDate == "" ||
          _this.baseData.schoolName == "" ||
          _this.baseData.specialty == "" ||
          _this.baseData.startDate == "" ||
          _this.baseData.uid == ""
        ) {
          _this.$toast("带星号为必填项，不能为空！");
          _this.addType = false;
        } else {
          _this.saveCredentialBox();
        }
      }
    },
    //保存学历证书
    saveCredentialBox() {
      let _this = this;
      _this.addType = false;
      if (_this.baseData.baseAnnexes != null) {
        if (_this.baseData.baseAnnexes.length < 1) {
          _this.baseData.baseAnnexes = null;
        }
      }
      _this.$api.userCenter.user.myInfo
        .saveDiploma(_this.mode, _this.baseData)
        .then(res => {
          if (res.code == "1") {
            if (_this.mode == "add") {
              _this.$toast("新增证书成功");
            } else {
              _this.$toast("修改证书成功");
            }
            setTimeout(function() {
              _this.addType = false;
              _this.backPage();
            }, 3000);
          } else {
            console.log(res.msg);
            _this.addType = false;
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.diplomaPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .fgx {
    width: 100%;
    height: 12px;
    background-color: #f6f6f6;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .summaryBox {
    .minRows.van-cell {
      overflow: initial;
      .van-field__body {
        textarea {
          min-height: 27px;
          text-align: right;
        }
      }
    }
  }
  .fileview {
    margin-bottom: 50px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    .btn {
      display: block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      background-color: #3c78f9;
      color: #fff;
      font-size: 16px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
  .editBtnbox.btnBox {
    .btn {
      width: 40%;
    }
    .btn:first-child {
      background-color: #f34646;
    }
  }
}
</style>